var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserAdd = function SvgUserAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 15.8767V17.6183C14.9124 17.3517 14.1051 17.2699 13.3128 17.3798C12.5204 17.4898 11.7659 17.7882 11.1128 18.2502C10.4596 18.7121 9.92687 19.324 9.55922 20.0345C9.19157 20.745 8.99977 21.5334 8.99992 22.3333L7.33325 22.3325C7.33299 21.3149 7.56569 20.3108 8.0135 19.397C8.46132 18.4832 9.11237 17.6841 9.91677 17.0609C10.7212 16.4376 11.6576 16.0068 12.6542 15.8014C13.6509 15.596 14.6813 15.6214 15.6666 15.8758V15.8767ZM13.9999 14.8333C11.2374 14.8333 8.99992 12.5958 8.99992 9.83334C8.99992 7.07084 11.2374 4.83334 13.9999 4.83334C16.7624 4.83334 18.9999 7.07084 18.9999 9.83334C18.9999 12.5958 16.7624 14.8333 13.9999 14.8333ZM13.9999 13.1667C15.8416 13.1667 17.3333 11.675 17.3333 9.83334C17.3333 7.99167 15.8416 6.5 13.9999 6.5C12.1583 6.5 10.6666 7.99167 10.6666 9.83334C10.6666 11.675 12.1583 13.1667 13.9999 13.1667ZM18.9999 18.1667V15.6667H20.6666V18.1667H23.1666V19.8333H20.6666V22.3333H18.9999V19.8333H16.4999V18.1667H18.9999Z",
    fill: "#191C22"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 28,
    x2: 27.7228,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC0F"
  })))));
};
export default SvgUserAdd;